import { createAgentProfileBindingApi } from "@wakeloop/api-client";
import type {
  AgentControllerPermissionMode,
  EnsureAgentProfilePrimaryBindingResponse,
} from "@wakeloop/schemas/types";
import { resolveBaseUrl } from "../config/base-url";
import type { WakeLoopProfile } from "../config/wakeloop-profiles-api";
import { buildWakeLoopRequestContextFromProfile } from "../config/wakeloop-request-context";
import { createCliApiClientFoundation } from "../space/api-client-foundation";

export async function updateAgentProfilePrimaryBindingAgentControllerPermissionMode(input: {
  agentControllerPermissionMode: AgentControllerPermissionMode;
  profile: WakeLoopProfile;
}): Promise<EnsureAgentProfilePrimaryBindingResponse> {
  const gatewayUrl = await resolveBaseUrl();
  const api = createAgentProfileBindingApi(
    createCliApiClientFoundation(gatewayUrl)
  );

  return await api.updatePrimaryBindingAgentControllerPermissionMode({
    agentControllerPermissionMode: input.agentControllerPermissionMode,
    agentProfileId: input.profile.wakeLoopProfileId,
    requestContext: buildWakeLoopRequestContextFromProfile({
      wakeLoopProfile: input.profile,
    }),
  });
}
